export default __webpack_public_path__ + "static/media/miele.967d9a05.svg";